export default class DeclaredGoodsModel {
    constructor(raw = {}) {

    }
}
